/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <prompt
    v-if="permitted"
    header="Assignment Saved to Templates"
    subtext="Would you like to assign this now?"
    :button1="button1"
    :button2="button2"
  />
</template>

<script>
import Prompt from '../forms/prompt';

export default {
  components: {Prompt},
  props: [ 'assignment' ],
  data() {
    return {
      button1: {
        text: 'NOT NOW',
        action: () => {
          this.$router.push({name: 'coach-dashboard'});
        }
      },
      button2: {
        text: 'ASSIGN',
        action: () => {
          this.$emit('advanceAssignmentEditor');
        }
      },
      permitted: false,
    };
  },
  created() {
    if ((this.assignment.userTargets.length || this.assignment.groupTargets.length) ||
      !this.assignment.isTemplate) {
      // Do not allow editing of existing assignments or non-templates
      return this.$router.push({name: 'coach-dashboard'});
    }
    this.permitted = true;
  },
};
</script>
